const getCompanyId = (flag, companyId = null) => {
  if (['CSM', 'CSMMaster'].includes(sessionStorage.getItem('role')) || flag) {
    return `company_id=${companyId || sessionStorage.getItem('company_id')}`;
  }
  return '';
};

export default getCompanyId;
